/* Carousel and movement tabs: no external dependencies. */
(() => {
  'use strict';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initMenus = root => {
    root.querySelectorAll('.uc-mega').forEach(menu => {
      if (menu.dataset.uoReady) return;
      menu.dataset.uoReady = 'true';
      menu.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 990px)').matches) return;
        document.querySelectorAll('.uc-mega[open]').forEach(other => {if (other !== menu) other.open = false;});
        menu.open = true;
      });
      menu.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && !menu.contains(document.activeElement)) menu.open = false;
      });
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('.uc-mega[open]').forEach(other => {if (other !== menu) other.open = false;});
      });
    });
  };
  initMenus(document);
  document.addEventListener('shopify:section:load', event => initMenus(event.target));
  function selectTab(section, index, focus = false) {
    const tabs = [...section.querySelectorAll('[data-uo-tab]')];
    const selected = tabs[index];
    if (!selected) return;
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
    });
    section.querySelectorAll('[data-uo-panel]').forEach(panel => {
      panel.hidden = panel.dataset.uoPanel !== selected.dataset.uoTab;
    });
    if (focus) selected.focus();
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-uo-tab]');
    if (tab) {
      const section = tab.closest('[data-uo-tabs]');
      selectTab(section, [...section.querySelectorAll('[data-uo-tab]')].indexOf(tab));
    }
    const control = event.target.closest('[data-uo-scroll]');
    if (control) {
      const container = control.closest('[role="tabpanel"], [data-uo-rail-section]');
      const rail = container?.querySelector('[data-uo-rail]');
      if (rail) rail.scrollBy({left: Number(control.dataset.uoScroll) * rail.clientWidth * .85, behavior: reducedMotion() ? 'auto' : 'smooth'});
    }
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-uo-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const section = tab.closest('[data-uo-tabs]');
    const tabs = [...section.querySelectorAll('[data-uo-tab]')];
    const current = tabs.indexOf(tab);
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    selectTab(section, index, true);
  });
})();
